/* eslint-disable no-restricted-globals */
export const getSearchArray = () => {
  return location.search
    .replace('?', '')
    .split('&')
    .map((e) => {
      return e.indexOf('=') !== -1
        ? e.split('=').map((a) => {
            return decodeURIComponent(a);
          })
        : [decodeURIComponent(e), true];
    });
};

export const getSearchMap = () => {
  const map = {};
  location.search
    .replace('?', '')
    .split('&')
    .map((e) => {
      const element = e.split('=');
      const index = decodeURIComponent(element[0]);
      if (element.length === 2) {
        // eslint-disable-next-line prefer-destructuring
        map[index] = decodeURIComponent(element[1]);
      } else {
        map[index] = true;
      }
      return e.indexOf('=') !== -1 ? e.split('=') : [e, true];
    });
  return map;
};

export const getSearchValue = (name) => {
  const arr = getSearchArray();
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][0] === name) {
      return arr[i][1];
    }
  }
  return null;
};
